// BOZUK EKLER RAPORU — depoda karşılığı olmayan dosya eklerini listeler ve
// onarmayı dener. HİÇBİR ŞEY SİLMEZ; yalnızca kayıtlı adresi düzeltir.
import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

export const BrokenAttachmentsCard = () => {
  const [rapor, setRapor] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const kilit = useRef(false);

  const tara = async () => {
    if (kilit.current) return;
    kilit.current = true;
    setYukleniyor(true);
    try {
      const { data } = await api.get("/maintenance/broken-attachments", { params: { limit: 200 } });
      setRapor(data);
    } catch (e) {
      toast.error(`Tarama yapılamadı (kod ${e?.response?.status || "ağ"})`);
    } finally {
      setYukleniyor(false);
      kilit.current = false;
    }
  };

  const tumunuOnar = async () => {
    if (kilit.current) return;
    kilit.current = true;
    setYukleniyor(true);
    try {
      const { data } = await api.post("/maintenance/repair-attachments", null, { params: { limit: 50 } });
      toast.success(data.mesaj, { duration: 10000 });
      await tara();
    } catch (e) {
      toast.error(`Onarım denenemedi (kod ${e?.response?.status || "ağ"})`);
    } finally {
      setYukleniyor(false);
      kilit.current = false;
    }
  };

  return (
    <div className="space-y-3" data-testid="broken-attachments-card">
      <div className="hud-text text-sertex-textMuted normal-case tracking-normal text-[11px]">
        Dosya eklerinin depoda gerçekten var olup olmadığını denetler. Hiçbir dosya veya
        kayıt silinmez; yalnızca kayıtlı adres düzeltilir.
      </div>
      <div className="flex gap-2">
        <button
          onClick={tara}
          disabled={yukleniyor}
          data-testid="broken-attachments-scan"
          className="flex-1 py-2 border border-sertex-cyan/40 text-sertex-cyan hover:bg-sertex-cyan/10 rounded hud-text transition-colors disabled:opacity-50"
        >
          {yukleniyor ? "TARANIYOR…" : "DOSYALARI DENETLE"}
        </button>
        {!!rapor?.depoda_yok && (
          <button
            onClick={tumunuOnar}
            disabled={yukleniyor}
            data-testid="broken-attachments-repair-all"
            className="flex-1 py-2 border border-amber-400/50 text-amber-200 hover:bg-amber-500/15 rounded hud-text transition-colors disabled:opacity-50"
          >
            TÜMÜNÜ ONARMAYI DENE
          </button>
        )}
      </div>
      {rapor && (
        <div className="space-y-2" data-testid="broken-attachments-summary">
          <div className="text-[12px] font-mono text-sertex-text">
            Toplam {rapor.toplam} · Sağlam {rapor.saglam} · Depoda yok {rapor.depoda_yok} · Görevi
            silinmiş {rapor.gorevi_silinmis_yetim}
          </div>
          {rapor.liste.length === 0 ? (
            <div className="text-[12px] font-mono text-emerald-300">
              Depoda karşılığı olmayan dosya yok.
            </div>
          ) : (
            <ul className="space-y-1" data-testid="broken-attachments-list">
              {rapor.liste.map((s) => (
                <li
                  key={s.attachment_id}
                  className="text-[11px] font-mono text-rose-200 border border-rose-400/20 rounded px-2 py-1"
                >
                  {s.original_filename} · {s.task_title} · {s.size} bayt ·{" "}
                  {(s.uploaded_at || "").slice(0, 10)} · {s.uploaded_by}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default BrokenAttachmentsCard;
